
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'deal-plans-ui',
  currentProjectVersion: 'static-1.2038',
  depVersions: {
  "deal-plans-ui": "static-1.2038",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "diff": "static-1.7",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26114",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5861",
  "hs-test-utils": "static-1.8294",
  "hub-http-shared-msw-handlers": "static-1.10562",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11749",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6718",
  "portals-platform-bend-plugin": "static-1.20",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7409",
  "react-colorpicker": "static-2.10473",
  "react-dlb": "static-1.88",
  "react-utils": "static-2.5533",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20259",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18339",
  "ui-components-test-utils": "static-1.5886",
  "avatar-components": "static-1.2759",
  "data-fetching-client": "static-1.9924",
  "deal-plans-lib": "static-1.1319",
  "ui-addon-emoji-picker": "static-1.10151",
  "FileManagerLib": "static-1.40049",
  "foundations-assets": "static-1.5147",
  "foundations-components": "static-1.8433",
  "foundations-theming": "static-1.4734",
  "framer-motion": "static-1.76",
  "hub-http": "static-1.6478",
  "hubspot-prosemirror": "static-1.18910",
  "hubspot-url-utils": "static-1.4297",
  "I18n": "static-7.1666",
  "js-cookie": "static-1.18",
  "payment-link-components": "static-1.24108",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1378",
  "quartz-auth": "static-1.1084",
  "quartz-config": "static-1.1187",
  "quartz-core": "static-1.6628",
  "quartz-routing": "static-1.839",
  "quick-fetch": "static-1.4108",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16981",
  "rpc-client-utils": "static-1.4929",
  "sanitize-text": "static-1.8418",
  "ui-addon-i18n": "static-1.11410",
  "ui-addon-react-router-dom": "static-1.9803",
  "UIComponents": "static-3.8695",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3593",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3686",
  "quartz-webpack": "static-1.3633",
  "bend-plugin-quartz-routing": "static-1.487",
  "customer-data-objects": "static-1.7952",
  "frontend-preferences-client": "static-1.8190",
  "graphql": "static-1.86",
  "laboratory-lib": "static-3.7417",
  "onboarding-scopes": "static-1.6718",
  "seat-types-lib": "static-1.658",
  "ui-addon-opt": "static-4.8629",
  "usage-tracker": "static-1.7621",
  "usage-tracker-core": "static-1.7471",
  "HeadJS": "static-2.792",
  "hs-test-utils-bend-plugin": "static-1.3405",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "ts-schema": "static-1.4270",
  "webpack-env": "static-1.54",
  "jasmine": "static-4.4579",
  "bender-build-tools": "static-1.3409",
  "hs-story-utils": "static-1.9691",
  "StyleGuideUI": "static-3.498",
  "data-token-picker": "static-1.16839",
  "icons": "static-2.676",
  "PatternValidationJS": "static-1.3160",
  "property-translator": "static-1.5663",
  "reference-resolvers-lite": "static-1.8367",
  "atom": "static-1.5350",
  "cssUtils": "static-1.883",
  "HubStyle": "static-2.12056",
  "merchandise-lib": "static-1.275",
  "purchase-motions-components": "static-1.6306",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.532",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5916",
  "ui-addon-draggable": "static-3.5021",
  "hub-http-janus": "static-1.872",
  "hubspotter-http": "static-1.4841",
  "fast-json-stable-stringify": "static-1.4",
  "crm-message-bus": "static-1.43684",
  "property-value-citations": "static-1.3101",
  "ui-business-units-lib": "static-1.9350",
  "ai-components-ui-library": "static-1.9641",
  "audio-components": "static-1.6296",
  "file-manager-components": "static-1.24409",
  "FileManagerCore": "static-1.39908",
  "FileManagerImages": "static-1.37560",
  "quartz-i18n": "static-1.1084",
  "react-virtualized": "static-2.104",
  "redux-thunk": "static-2.77",
  "video-components": "static-1.14097",
  "bend-plugin-foundations-components": "static-1.4702",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2450",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.66",
  "react-select-plus": "static-1.109",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2539",
  "ui-fonts": "static-1.1011",
  "ui-images": "static-2.1236",
  "bend-plugin-foundations-theming": "static-1.3217",
  "foundations-theming-base": "static-1.3719",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.269",
  "content-assistance-lib": "static-1.8156",
  "content-media-capture": "static-1.5367",
  "customer-data-ui-utilities": "static-1.10094",
  "knowledge-content-types": "static-1.8632",
  "ui-shepherd-react": "static-3.10532",
  "video-components-external": "static-1.12095",
  "video-data-lib": "static-1.35753",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "commerce-tours-lib": "static-1.6564",
  "customer-data-properties": "static-1.52487",
  "getting-started-shared-tasks": "static-1.19164",
  "growth-onboarding-reliability": "static-1.5345",
  "onboarding-tours": "static-1.17068",
  "sales-checkout-service-client": "static-1.3794",
  "ui-addon-iframeable": "static-1.9339",
  "user-context": "static-1.5382",
  "interframe": "static-3.5021",
  "usage-tracker-multi": "static-1.6035",
  "hubspotter-http-shared-msw-handlers": "static-1.10560",
  "opentelemetry-fe-types": "static-1.34",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.572",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.409",
  "quartz-head": "static-1.1074",
  "quartz-test": "static-1.1084",
  "quartz-tracking": "static-1.788",
  "trellis-components": "static-1.2558",
  "usage-tracker-container": "static-1.7611",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.339",
  "chirp-fetch": "static-1.2159",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4739",
  "inbound-db-properties-service-client": "static-1.4033",
  "superstore": "static-1.5023",
  "feedback-loader": "static-1.29762",
  "sassPrefix": "static-1.163",
  "batch-promise": "static-1.1808",
  "external-options-client-types": "static-1.4316",
  "framework-data-schema-resolvers": "static-1.7158",
  "foundations-components-legacy": "static-1.1458",
  "purchase-motions-api": "static-1.6309",
  "signup-constants": "static-1.19548",
  "signup-ui-url-generator": "static-2.8326",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.75",
  "restore-request-side-panel-lib": "static-1.1605",
  "crm-links": "static-1.6594",
  "customer-data-objects-ui-components": "static-1.13295",
  "hs-resources": "static-1.455",
  "inbound-db-meta-service-client": "static-1.3718",
  "pulse": "static-1.892",
  "smart-property-lib": "static-1.8219",
  "magpie-lib": "static-1.5731",
  "navigation-messaging": "static-1.8081",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.8447",
  "chatspot-core": "static-1.22762",
  "ContentUtils": "static-1.69065",
  "copilot-toolkit": "static-1.11785",
  "breeze-engine-lib": "static-1.1623",
  "apollo-link-hub-http": "static-2.4921",
  "immer": "static-1.94",
  "immerable": "static-1.4416",
  "breeze-artifacts-sdk": "static-1.242",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "ui-universal-auth": "static-1.9334",
  "urlinator": "static-1.4798",
  "video-embed": "static-1.36587",
  "content-icons-ui": "static-1.2328",
  "social-insights-client-types": "static-1.22685",
  "ui-addon-video-player": "static-1.8968",
  "ui-coaching-tips": "static-1.29250",
  "content-media-composition-data-lib": "static-1.13171",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4690",
  "react-dnd-compat": "static-1.4882",
  "react-immutable-render-mixin": "static-1.9",
  "content-media-compositions": "static-2.17178",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5191",
  "media-bridge-lib": "static-1.19360",
  "commerce-products-lib": "static-1.10458",
  "growth-data-modal": "static-1.5847",
  "hubspot-apollo-client": "static-1.5144",
  "onboarding-tours-client": "static-1.5282",
  "calling-global-api": "static-1.65470",
  "calling-internal-common": "static-1.31583",
  "calling-lifecycle-internal": "static-1.66852",
  "calling-lifecycle-messages": "static-1.59146",
  "conditional-properties-service-client": "static-1.3988",
  "crm-index-visualization-core": "static-1.4499",
  "crm-pipelines-api-client-types": "static-1.4324",
  "customer-data-properties-shared-msw-handlers": "static-1.9889",
  "customer-data-property-utils": "static-1.8366",
  "formula-editor": "static-1.14701",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4402",
  "meetings-icalendar-utils-lib": "static-1.901",
  "multi-currency-client-types": "static-1.3885",
  "object-builder-ui-client": "static-1.49591",
  "pipeline-validation-client-types": "static-1.4159",
  "smart-data-capture-core": "static-1.67",
  "tiered-pricing": "static-1.1903",
  "topics-actions-lib": "static-1.429",
  "trial-components-library": "static-1.14054",
  "ui-addon-form-validation": "static-1.11248",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3328",
  "growth-onboarding-next-action-utils": "static-1.2633",
  "navigation-components": "static-1.18754",
  "onboarding-tours-utils": "static-1.1134",
  "ui-shepherd-tracker": "static-1.7913",
  "getting-started-shared-tasks-store": "static-1.18282",
  "usage-tracker-anonymous": "static-1.6038",
  "usage-tracker-public": "static-1.7432",
  "opentelemetry-web": "static-1.11",
  "usage-tracker-session-replay": "static-1.5307",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1232",
  "tanstack-virtual": "static-1.36",
  "fdsr-migration-layer": "static-1.277",
  "framework-builder-read-service-client": "static-1.4198",
  "framework-data-schema-quick-fetch": "static-1.7063",
  "persist-promise": "static-1.3965",
  "location-customization-utils-lib": "static-1.10031",
  "event-emitter": "static-1.1219",
  "bend-plugin-pulse": "static-1.395",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.599",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10645",
  "fsm": "static-1.4009",
  "policy-lib": "static-1.7062",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10708",
  "reactive-lib": "static-1.985",
  "simple-logging-lib": "static-1.3315",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.5079",
  "integrations-lib": "static-1.16969",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.601",
  "breeze-engine-core": "static-1.901",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "unified-auth-core-lib": "static-1.1130",
  "outpost": "static-1.4423",
  "growth-onboarding-feedback-components": "static-1.6849",
  "commerce-permissions": "static-1.1042",
  "customer-data-tracking": "static-1.7146",
  "products-iframe-lib": "static-1.8531",
  "products-ui-components-shared-msw-handlers": "static-1.10944",
  "onboarding-data-sync-lib": "static-1.2445",
  "hubspot-apollo-cache": "static-1.603",
  "calling-error-reporting": "static-1.31590",
  "shared-worker-versioning": "static-1.11306",
  "calling-usage-tracker": "static-1.6802",
  "voice-sms-access-library": "static-1.1956",
  "conversations-skeleton-state": "static-1.7512",
  "crm-index-associations-lib": "static-1.6706",
  "sales-views-client-types": "static-1.4520",
  "bark-lib": "static-1.16774",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6154",
  "react-codemirror": "static-1.10903",
  "embedded-academy-lib": "static-1.15429",
  "hubs-service-types": "static-1.1522",
  "growth-onboarding-next-action-components": "static-1.2661",
  "user-context-client": "static-1.4775",
  "nest": "static-1.501",
  "amplitude-session-replay-browser": "static-1.60",
  "crm-record-cards-service-types": "static-1.3761",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4774",
  "storybook-react": "static-1.37",
  "flux-actions": "static-1.363",
  "integrations-error-boundary-lib": "static-1.14384",
  "integrations-tracking-lib": "static-1.5872",
  "native-integrations-shared-strings": "static-1.8043",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10635",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.848",
  "InboxConnectUtils": "static-4.15494",
  "meetings-connect-utils-lib": "static-1.7873",
  "calling-orchestration-schema": "static-1.36733",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16303",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.14889",
  "universal-page-editor-lib": "static-1.3271",
  "adobe-sign-auth-lib": "static-1.394",
  "ads-unified-auth-lib": "static-1.1178",
  "google-sheets-integration-lib": "static-1.968",
  "microsoft-drive-auth-lib": "static-1.66",
  "surveymonkey-integration-lib": "static-1.412",
  "slack-ui-library": "static-1.10663",
  "hub-http-contrib": "static-1.3304",
  "ui-addon-sales-email": "static-1.5478",
  "academy-service-client": "static-1.3954",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4669",
  "trellis-ecosystem": "static-1.7584",
  "wootric-nps": "static-1.7176",
  "marketplace-ui-apps-core": "static-1.19177",
  "marketplace-ui-common": "static-1.20645",
  "developer-experience-shared-components": "static-1.10768",
  "immutable-less": "static-1.4916",
  "marketplace-ui-client-types": "static-1.18052",
  "ui-addon-integrations-directory-panel": "static-2.8290",
  "ui-extensibility-client-types": "static-1.4183",
  "ai-settings-ui-library": "static-1.8276",
  "nav-meta": "static-1.30391",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.933",
  "apps-service-types": "static-1.4006",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3473"
},
  depPathPrefixes: {
  "deal-plans-ui": "/deal-plans-ui/static-1.2038",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "diff": "/diff/static-1.7",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26114",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5861",
  "hs-test-utils": "/hs-test-utils/static-1.8294",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10562",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11749",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6718",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.20",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7409",
  "react-colorpicker": "/react-colorpicker/static-2.10473",
  "react-dlb": "/react-dlb/static-1.88",
  "react-utils": "/react-utils/static-2.5533",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20259",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18339",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5886",
  "avatar-components": "/avatar-components/static-1.2759",
  "data-fetching-client": "/data-fetching-client/static-1.9924",
  "deal-plans-lib": "/deal-plans-lib/static-1.1319",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10151",
  "FileManagerLib": "/FileManagerLib/static-1.40049",
  "foundations-assets": "/foundations-assets/static-1.5147",
  "foundations-components": "/foundations-components/static-1.8433",
  "foundations-theming": "/foundations-theming/static-1.4734",
  "framer-motion": "/framer-motion/static-1.76",
  "hub-http": "/hub-http/static-1.6478",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18910",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "I18n": "/I18n/static-7.1666",
  "js-cookie": "/js-cookie/static-1.18",
  "payment-link-components": "/payment-link-components/static-1.24108",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1378",
  "quartz-auth": "/quartz-auth/static-1.1084",
  "quartz-config": "/quartz-config/static-1.1187",
  "quartz-core": "/quartz-core/static-1.6628",
  "quartz-routing": "/quartz-routing/static-1.839",
  "quick-fetch": "/quick-fetch/static-1.4108",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16981",
  "rpc-client-utils": "/rpc-client-utils/static-1.4929",
  "sanitize-text": "/sanitize-text/static-1.8418",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11410",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9803",
  "UIComponents": "/UIComponents/static-3.8695",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3593",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3686",
  "quartz-webpack": "/quartz-webpack/static-1.3633",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.487",
  "customer-data-objects": "/customer-data-objects/static-1.7952",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8190",
  "graphql": "/graphql/static-1.86",
  "laboratory-lib": "/laboratory-lib/static-3.7417",
  "onboarding-scopes": "/onboarding-scopes/static-1.6718",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "usage-tracker": "/usage-tracker/static-1.7621",
  "usage-tracker-core": "/usage-tracker-core/static-1.7471",
  "HeadJS": "/HeadJS/static-2.792",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3405",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "ts-schema": "/ts-schema/static-1.4270",
  "webpack-env": "/webpack-env/static-1.54",
  "jasmine": "/jasmine/static-4.4579",
  "bender-build-tools": "/bender-build-tools/static-1.3409",
  "hs-story-utils": "/hs-story-utils/static-1.9691",
  "StyleGuideUI": "/StyleGuideUI/static-3.498",
  "data-token-picker": "/data-token-picker/static-1.16839",
  "icons": "/icons/static-2.676",
  "PatternValidationJS": "/PatternValidationJS/static-1.3160",
  "property-translator": "/property-translator/static-1.5663",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8367",
  "atom": "/atom/static-1.5350",
  "cssUtils": "/cssUtils/static-1.883",
  "HubStyle": "/HubStyle/static-2.12056",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "purchase-motions-components": "/purchase-motions-components/static-1.6306",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5916",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5021",
  "hub-http-janus": "/hub-http-janus/static-1.872",
  "hubspotter-http": "/hubspotter-http/static-1.4841",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "crm-message-bus": "/crm-message-bus/static-1.43684",
  "property-value-citations": "/property-value-citations/static-1.3101",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9350",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9641",
  "audio-components": "/audio-components/static-1.6296",
  "file-manager-components": "/file-manager-components/static-1.24409",
  "FileManagerCore": "/FileManagerCore/static-1.39908",
  "FileManagerImages": "/FileManagerImages/static-1.37560",
  "quartz-i18n": "/quartz-i18n/static-1.1084",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux-thunk": "/redux-thunk/static-2.77",
  "video-components": "/video-components/static-1.14097",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4702",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2450",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "react-select-plus": "/react-select-plus/static-1.109",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2539",
  "ui-fonts": "/ui-fonts/static-1.1011",
  "ui-images": "/ui-images/static-2.1236",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3217",
  "foundations-theming-base": "/foundations-theming-base/static-1.3719",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.269",
  "content-assistance-lib": "/content-assistance-lib/static-1.8156",
  "content-media-capture": "/content-media-capture/static-1.5367",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10094",
  "knowledge-content-types": "/knowledge-content-types/static-1.8632",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10532",
  "video-components-external": "/video-components-external/static-1.12095",
  "video-data-lib": "/video-data-lib/static-1.35753",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6564",
  "customer-data-properties": "/customer-data-properties/static-1.52487",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19164",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5345",
  "onboarding-tours": "/onboarding-tours/static-1.17068",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3794",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9339",
  "user-context": "/user-context/static-1.5382",
  "interframe": "/interframe/static-3.5021",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6035",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10560",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.34",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.572",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.409",
  "quartz-head": "/quartz-head/static-1.1074",
  "quartz-test": "/quartz-test/static-1.1084",
  "quartz-tracking": "/quartz-tracking/static-1.788",
  "trellis-components": "/trellis-components/static-1.2558",
  "usage-tracker-container": "/usage-tracker-container/static-1.7611",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.339",
  "chirp-fetch": "/chirp-fetch/static-1.2159",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4739",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4033",
  "superstore": "/superstore/static-1.5023",
  "feedback-loader": "/feedback-loader/static-1.29762",
  "sassPrefix": "/sassPrefix/static-1.163",
  "batch-promise": "/batch-promise/static-1.1808",
  "external-options-client-types": "/external-options-client-types/static-1.4316",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7158",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1458",
  "purchase-motions-api": "/purchase-motions-api/static-1.6309",
  "signup-constants": "/signup-constants/static-1.19548",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8326",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.75",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1605",
  "crm-links": "/crm-links/static-1.6594",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13295",
  "hs-resources": "/hs-resources/static-1.455",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "pulse": "/pulse/static-1.892",
  "smart-property-lib": "/smart-property-lib/static-1.8219",
  "magpie-lib": "/magpie-lib/static-1.5731",
  "navigation-messaging": "/navigation-messaging/static-1.8081",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.8447",
  "chatspot-core": "/chatspot-core/static-1.22762",
  "ContentUtils": "/ContentUtils/static-1.69065",
  "copilot-toolkit": "/copilot-toolkit/static-1.11785",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1623",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4921",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4416",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.242",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "ui-universal-auth": "/ui-universal-auth/static-1.9334",
  "urlinator": "/urlinator/static-1.4798",
  "video-embed": "/video-embed/static-1.36587",
  "content-icons-ui": "/content-icons-ui/static-1.2328",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8968",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29250",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13171",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4690",
  "react-dnd-compat": "/react-dnd-compat/static-1.4882",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "content-media-compositions": "/content-media-compositions/static-2.17178",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5191",
  "media-bridge-lib": "/media-bridge-lib/static-1.19360",
  "commerce-products-lib": "/commerce-products-lib/static-1.10458",
  "growth-data-modal": "/growth-data-modal/static-1.5847",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5144",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5282",
  "calling-global-api": "/calling-global-api/static-1.65470",
  "calling-internal-common": "/calling-internal-common/static-1.31583",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66852",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59146",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3988",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4499",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4324",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9889",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8366",
  "formula-editor": "/formula-editor/static-1.14701",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4402",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.901",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3885",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49591",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4159",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.67",
  "tiered-pricing": "/tiered-pricing/static-1.1903",
  "topics-actions-lib": "/topics-actions-lib/static-1.429",
  "trial-components-library": "/trial-components-library/static-1.14054",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3328",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2633",
  "navigation-components": "/navigation-components/static-1.18754",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1134",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7913",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18282",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6038",
  "usage-tracker-public": "/usage-tracker-public/static-1.7432",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5307",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1232",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.277",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4198",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7063",
  "persist-promise": "/persist-promise/static-1.3965",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10031",
  "event-emitter": "/event-emitter/static-1.1219",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.395",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.599",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10645",
  "fsm": "/fsm/static-1.4009",
  "policy-lib": "/policy-lib/static-1.7062",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10708",
  "reactive-lib": "/reactive-lib/static-1.985",
  "simple-logging-lib": "/simple-logging-lib/static-1.3315",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.5079",
  "integrations-lib": "/integrations-lib/static-1.16969",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.601",
  "breeze-engine-core": "/breeze-engine-core/static-1.901",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1130",
  "outpost": "/outpost/static-1.4423",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6849",
  "commerce-permissions": "/commerce-permissions/static-1.1042",
  "customer-data-tracking": "/customer-data-tracking/static-1.7146",
  "products-iframe-lib": "/products-iframe-lib/static-1.8531",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10944",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2445",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.603",
  "calling-error-reporting": "/calling-error-reporting/static-1.31590",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11306",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6802",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1956",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6706",
  "sales-views-client-types": "/sales-views-client-types/static-1.4520",
  "bark-lib": "/bark-lib/static-1.16774",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6154",
  "react-codemirror": "/react-codemirror/static-1.10903",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15429",
  "hubs-service-types": "/hubs-service-types/static-1.1522",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2661",
  "user-context-client": "/user-context-client/static-1.4775",
  "nest": "/nest/static-1.501",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3761",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4774",
  "storybook-react": "/storybook-react/static-1.37",
  "flux-actions": "/flux-actions/static-1.363",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14384",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5872",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8043",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10635",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.848",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15494",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7873",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36733",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16303",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.14889",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3271",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.394",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1178",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.968",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.66",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.412",
  "slack-ui-library": "/slack-ui-library/static-1.10663",
  "hub-http-contrib": "/hub-http-contrib/static-1.3304",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5478",
  "academy-service-client": "/academy-service-client/static-1.3954",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4669",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7584",
  "wootric-nps": "/wootric-nps/static-1.7176",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19177",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20645",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10768",
  "immutable-less": "/immutable-less/static-1.4916",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18052",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8290",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4183",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8276",
  "nav-meta": "/nav-meta/static-1.30391",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.933",
  "apps-service-types": "/apps-service-types/static-1.4006",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3473"
}
};
